export default __webpack_public_path__ + "static/media/typeHelicopter.5c12dcb4.svg";